const initialState = {
  topUp: {
    autoTopUpData: {
      type: 'byLimit',
      trigger: 1000,
      amount: 1000
    },
    selectedTopUpTypes: ['without'],
    singleTopUpData: {
      amount: 1000
    }
  }
}

const OrderTopUpModule = {
  namespaced: true,
  state: initialState,
  mutations: {
    storeAutoTopUpData (state, autoTopUpData) {
      state.topUp.autoTopUpData = autoTopUpData
    },
    storeSingleTopUpData (state, amount) {
      state.topUp.singleTopUpData.amount = amount
    },
    storeSelection (state, selectedToUpTypes) {
      state.topUp.selectedTopUpTypes = [
        ...selectedToUpTypes
      ]
    }
  },
  getters: {
    selectedTopUpTypes: state => {
      return state.topUp.selectedTopUpTypes
    },
    topUp: state => state.topUp.autoTopUpData,
    singleTopUpAmount: state => state.topUp.singleTopUpData.amount,
    hasSingleTopUp: state => {
      return state.topUp.selectedTopUpTypes.includes('single')
    },
    hasAutoTopUp: state => {
      return state.topUp.selectedTopUpTypes.includes('auto')
    },
    withoutTopUp: state => {
      return state.topUp.selectedTopUpTypes.includes('without')
    },
    hasTopUp: (state, getters) => {
      return getters.hasSingleTopUp || getters.hasAutoTopUp
    },
    topUpCore (state, getters) {
      if (getters.hasTopUp === false) {
        return null
      }
      const topUp = {}
      if (getters.hasAutoTopUp) {
        if (state.topUp.autoTopUpData.type === 'byLimit') {
          topUp.autoTopup = {
            amount: state.topUp.autoTopUpData.amount || 0,
            trigger: state.topUp.autoTopUpData.trigger || 0,
            type: 'ACCOUNT_BALANCE'
          }
        } else if (state.topUp.autoTopUpData.type === 'monthly') {
          topUp.autoTopup = {
            amount: state.topUp.autoTopUpData.amount || 0,
            trigger: 2,
            type: 'DAY_OF_MONTH'
          }
        }
      }
      if (getters.hasSingleTopUp) {
        topUp.singleTopupAmount = state.topUp.singleTopUpData.amount
      } else {
        topUp.singleTopupAmount = null
      }
      return topUp
    }
  }
}

export default OrderTopUpModule
